import { usePlosTranslations } from "../../../../contexts/PlosTranslationsContext";
import VideoCamera from "../../../../img/icons/video-camera.svg?react";
import { PulseBroadcaster } from "../../../../utils/pulse/types";
import { Button } from "../../../buttons/Button";
import {
  broadcaster,
  broadcasterItem,
  broadcasterList,
  buttonText,
  multipleBroadcastersButton,
  videoCamera,
} from "../fixture.css";
import { broadcasterLink } from "../FixtureBroadcasters/fixtureBroadcasters.css";
import Logo from "../FixtureBroadcasters/Logo";
import MultipleBroadcastersDialog from "../FixtureBroadcasters/MultipleBroadcasters";
import { getBroadcasterKey } from "../FixtureBroadcasters/utils";

const BroadcasterInfo = ({
  broadcasterInfo,
  dialogOpen,
  setDialogOpen,
}: {
  broadcasterInfo: PulseBroadcaster[];
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
}) => {
  const { fixtures, opensInNewTab } = usePlosTranslations();
  return (
    <div className={broadcaster}>
      {broadcasterInfo.length > 2 ? (
        <div>
          <Button
            onPress={() => {
              setDialogOpen(true);
            }}
            className={multipleBroadcastersButton}
          >
            <VideoCamera
              aria-label={fixtures.multipleBroadcasters}
              className={videoCamera}
            />
            <span className={buttonText}>{fixtures.multipleBroadcasters}</span>
          </Button>
          <MultipleBroadcastersDialog
            broadcasters={broadcasterInfo}
            open={dialogOpen}
            handleClose={() => setDialogOpen(false)}
          />
        </div>
      ) : broadcasterInfo.length === 2 ? (
        <ul className={broadcasterList}>
          {broadcasterInfo.map((b) => (
            <li className={broadcasterItem} key={getBroadcasterKey(b)}>
              <a
                href={b.link}
                className={broadcasterLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                aria-label={opensInNewTab}
              >
                <Logo abbreviation={b.abbreviation} name={b.name} />
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <a
          href={broadcasterInfo[0].link}
          className={broadcasterLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          aria-label={opensInNewTab}
        >
          <Logo
            abbreviation={broadcasterInfo[0].abbreviation}
            name={broadcasterInfo[0].name}
          />
        </a>
      )}
    </div>
  );
};

export default BroadcasterInfo;
